/**
 * Service Worker registration
 * Dispatches a custom event when an update is detected.
 */

/**
 * Register the service worker and listen for updates
 */
export function registerSW() {
  if (!('serviceWorker' in navigator)) {
    console.warn('[SW] Service Workers non supportes par ce navigateur');
    return;
  }

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('[SW] Enregistre, scope:', registration.scope);

      // Listen for new SW ready
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
            // New version activated, notify UI
            window.dispatchEvent(new CustomEvent('sw-update-available'));
          }
        });
      });
    } catch (err) {
      console.error('[SW] Erreur d\'enregistrement:', err.message);
    }
  });

  // Also listen for messages from SW
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SW_UPDATED') {
      window.dispatchEvent(new CustomEvent('sw-update-available'));
    }
  });
}
